exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".src-components-shared-Card-card{border:2px solid #b3b3b3 !important;border-radius:0 !important}.src-components-shared-Card-card .src-components-shared-Card-header{font-weight:bold;color:#15284b;border-bottom:none;border-radius:0 !important;background-color:#fff !important}.src-components-shared-Card-card .src-components-shared-Card-body{border-top:none}", ""]);

// exports
exports.locals = {
	"card": "src-components-shared-Card-card",
	"header": "src-components-shared-Card-header",
	"body": "src-components-shared-Card-body"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[path][local]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/components/shared/Card/styles.scss
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1,"modules":true,"localIdentName":"[path][local]"}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/components/shared/Card/styles.scss
// module chunks = 1